import React from "react";

const TabContentDefault = (props) => {
  return (
    <div
      role="tabpanel"
      id={props.index ? props.index : null}
      style={{ paddingTop: "24px" }}
    >
      {props.children}
    </div>
  );
};

export default TabContentDefault;
